var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "manage-goods-container" },
    [
      _vm._m(0),
      _c("StatusChangeBar", { on: { statusChange: _vm.statusChange } }),
      _c("SearchBar", {
        attrs: { selfOperatedShop: _vm.selfOperatedShop },
        on: { searchClick: _vm.searchClick, resetClick: _vm.resetClick }
      }),
      _c(
        "div",
        { staticClass: "table-box" },
        [
          _c(
            "el-table",
            {
              directives: [
                {
                  name: "loading",
                  rawName: "v-loading",
                  value: _vm.isLoading,
                  expression: "isLoading"
                }
              ],
              staticStyle: { width: "100%", "margin-bottom": "20px" },
              attrs: {
                data: _vm.spuList,
                "row-key": "goodsId",
                border: "",
                "tree-props": {
                  children: "children",
                  hasChildren: "hasChildren"
                }
              }
            },
            [
              _vm._v("\n      >\n      "),
              _c("el-table-column", {
                attrs: { type: "index", width: "50" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function(scope) {
                      return [
                        scope.row.isSpu
                          ? [
                              _c("el-checkbox", {
                                on: { change: _vm.oneSpuCheckedChange },
                                model: {
                                  value: scope.row.checked,
                                  callback: function($$v) {
                                    _vm.$set(scope.row, "checked", $$v)
                                  },
                                  expression: "scope.row.checked"
                                }
                              })
                            ]
                          : _vm._e()
                      ]
                    }
                  }
                ])
              }),
              _c("el-table-column", {
                attrs: { prop: "name", label: "商品名称", "min-width": "20%" }
              }),
              _c("el-table-column", {
                attrs: {
                  align: "center",
                  label: "商品图片",
                  "min-width": "15%"
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function(scope) {
                      return [
                        _c("el-image", {
                          staticStyle: { width: "50px", height: "50px" },
                          attrs: {
                            src: scope.row.picUrl + "?imageView2/1/w/50/h/50",
                            fit: "cover"
                          }
                        })
                      ]
                    }
                  }
                ])
              }),
              _c("el-table-column", {
                attrs: { label: "规格", align: "ceter", "min-width": "10%" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function(scope) {
                      return [
                        scope.row.specType === 0
                          ? [
                              _vm._v(
                                _vm._s(
                                  scope.row.children &&
                                    scope.row.children[0].skuSpecsIndex
                                )
                              )
                            ]
                          : [
                              !scope.row.isSpu
                                ? _c("div", [
                                    _vm._v(
                                      "\n              " +
                                        _vm._s(scope.row.skuSpecsIndex) +
                                        "\n            "
                                    )
                                  ])
                                : _c(
                                    "div",
                                    { staticClass: "nodata_line_color" },
                                    [_vm._v("——")]
                                  )
                            ]
                      ]
                    }
                  }
                ])
              }),
              _c("el-table-column", {
                attrs: { label: "价格(元)", "min-width": "10%" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function(scope) {
                      return [
                        !scope.row.specType
                          ? _c(
                              "div",
                              { staticClass: "flex items-center" },
                              [
                                scope.row && scope.row.laddersPriceStr
                                  ? [
                                      _vm._v(
                                        "\n              " +
                                          _vm._s(scope.row.laddersPriceStr) +
                                          "\n            "
                                      )
                                    ]
                                  : [
                                      _vm._v(
                                        "\n              " +
                                          _vm._s(
                                            scope.row &&
                                              scope.row.marketPriceStr
                                          ) +
                                          "\n            "
                                      )
                                    ],
                                !scope.row.isoa && !scope.row.usefulLaddersPrice
                                  ? [
                                      _c(
                                        "el-popover",
                                        {
                                          attrs: {
                                            placement: "right",
                                            width: "250",
                                            trigger: "click"
                                          },
                                          model: {
                                            value:
                                              scope.row.marketPriceStrVisible,
                                            callback: function($$v) {
                                              _vm.$set(
                                                scope.row,
                                                "marketPriceStrVisible",
                                                $$v
                                              )
                                            },
                                            expression:
                                              "scope.row.marketPriceStrVisible"
                                          }
                                        },
                                        [
                                          _c(
                                            "div",
                                            [
                                              _c("el-input", {
                                                attrs: {
                                                  maxlength: "20",
                                                  placeholder: "请输入价格",
                                                  oninput:
                                                    "value=value.replace(/^([0-9-]\\d*\\.?\\d{0,6})?.*$/,'$1')"
                                                },
                                                model: {
                                                  value:
                                                    scope.row.marketPriceStrTem,
                                                  callback: function($$v) {
                                                    _vm.$set(
                                                      scope.row,
                                                      "marketPriceStrTem",
                                                      $$v
                                                    )
                                                  },
                                                  expression:
                                                    "scope.row.marketPriceStrTem"
                                                }
                                              })
                                            ],
                                            1
                                          ),
                                          _c(
                                            "div",
                                            {
                                              staticClass: "text-right mar10-t"
                                            },
                                            [
                                              _c(
                                                "el-button",
                                                {
                                                  attrs: { size: "mini" },
                                                  on: {
                                                    click: function($event) {
                                                      scope.row.marketPriceStrVisible = false
                                                    }
                                                  }
                                                },
                                                [_vm._v("取消")]
                                              ),
                                              _c(
                                                "el-button",
                                                {
                                                  attrs: {
                                                    size: "mini",
                                                    type: "primary"
                                                  },
                                                  on: {
                                                    click: function($event) {
                                                      return _vm.marketPriceStrChange(
                                                        scope.row
                                                      )
                                                    }
                                                  }
                                                },
                                                [_vm._v("确定")]
                                              )
                                            ],
                                            1
                                          ),
                                          _c("i", {
                                            staticClass:
                                              "el-icon-edit pointer mar5-l",
                                            attrs: { slot: "reference" },
                                            slot: "reference"
                                          })
                                        ]
                                      )
                                    ]
                                  : _vm._e()
                              ],
                              2
                            )
                          : [
                              _c("div", { staticClass: "nodata_line_color" }, [
                                _vm._v("——")
                              ])
                            ]
                      ]
                    }
                  }
                ])
              }),
              _c("el-table-column", {
                attrs: { label: "单位", "min-width": "10%" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function(scope) {
                      return [
                        scope.row.specType === 0
                          ? [
                              _vm._v(
                                _vm._s(
                                  scope.row.children &&
                                    scope.row.children[0].unitName
                                )
                              )
                            ]
                          : [
                              !scope.row.isSpu
                                ? _c("div", [
                                    _vm._v(
                                      "\n              " +
                                        _vm._s(scope.row.unitName) +
                                        "\n            "
                                    )
                                  ])
                                : _c(
                                    "div",
                                    { staticClass: "nodata_line_color" },
                                    [_vm._v("——")]
                                  )
                            ]
                      ]
                    }
                  }
                ])
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "currQuantity",
                  label: "库存",
                  "min-width": "10%"
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function(scope) {
                      return [
                        !scope.row.specType
                          ? _c(
                              "div",
                              { staticClass: "flex items-center" },
                              [
                                _vm._v(
                                  "\n            " +
                                    _vm._s(
                                      (scope.row && scope.row.currQuantity) ||
                                        "0"
                                    ) +
                                    "\n            "
                                ),
                                _c(
                                  "el-popover",
                                  {
                                    attrs: {
                                      placement: "right",
                                      width: "250",
                                      trigger: "click"
                                    },
                                    model: {
                                      value: scope.row.visible,
                                      callback: function($$v) {
                                        _vm.$set(scope.row, "visible", $$v)
                                      },
                                      expression: "scope.row.visible"
                                    }
                                  },
                                  [
                                    _c(
                                      "div",
                                      [
                                        _c("el-input", {
                                          attrs: {
                                            maxlength: "10",
                                            placeholder: "请输入库存",
                                            oninput:
                                              "value = value.replace(/[^0-9]/g, '')"
                                          },
                                          model: {
                                            value: scope.row.currQuantityTem,
                                            callback: function($$v) {
                                              _vm.$set(
                                                scope.row,
                                                "currQuantityTem",
                                                $$v
                                              )
                                            },
                                            expression:
                                              "scope.row.currQuantityTem"
                                          }
                                        })
                                      ],
                                      1
                                    ),
                                    _c(
                                      "div",
                                      { staticClass: "text-right mar10-t" },
                                      [
                                        _c(
                                          "el-button",
                                          {
                                            attrs: { size: "mini" },
                                            on: {
                                              click: function($event) {
                                                scope.row.visible = false
                                              }
                                            }
                                          },
                                          [_vm._v("取消")]
                                        ),
                                        _c(
                                          "el-button",
                                          {
                                            attrs: {
                                              size: "mini",
                                              type: "primary"
                                            },
                                            on: {
                                              click: function($event) {
                                                return _vm.currQuantityChange(
                                                  scope.row
                                                )
                                              }
                                            }
                                          },
                                          [_vm._v("确定")]
                                        )
                                      ],
                                      1
                                    ),
                                    _c("i", {
                                      staticClass:
                                        "el-icon-edit pointer mar5-l",
                                      attrs: { slot: "reference" },
                                      slot: "reference"
                                    })
                                  ]
                                )
                              ],
                              1
                            )
                          : [
                              _c("div", { staticClass: "nodata_line_color" }, [
                                _vm._v("——")
                              ])
                            ]
                      ]
                    }
                  }
                ])
              }),
              _c("el-table-column", {
                attrs: { label: "分类", "min-width": "10%" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function(scope) {
                      return [
                        scope.row.isSpu
                          ? [
                              scope.row.goodsType
                                ? _c(
                                    "div",
                                    {
                                      staticClass: "flex items-center",
                                      on: {
                                        click: function($event) {
                                          return _vm.showCategroyDialogClick(
                                            scope.row,
                                            true
                                          )
                                        }
                                      }
                                    },
                                    [
                                      _c("div", [
                                        _vm._v(_vm._s(scope.row.goodsType))
                                      ]),
                                      _c("i", {
                                        staticClass:
                                          "el-icon-edit pointer mar5-l",
                                        attrs: { slot: "reference" },
                                        slot: "reference"
                                      })
                                    ]
                                  )
                                : _c(
                                    "el-button",
                                    {
                                      attrs: { type: "text" },
                                      on: {
                                        click: function($event) {
                                          return _vm.showCategroyDialogClick(
                                            scope.row
                                          )
                                        }
                                      }
                                    },
                                    [_vm._v("+添加")]
                                  )
                            ]
                          : [
                              _c("div", { staticClass: "nodata_line_color" }, [
                                _vm._v("——")
                              ])
                            ]
                      ]
                    }
                  }
                ])
              }),
              _c("el-table-column", {
                attrs: { label: "状态", "min-width": "10%" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function(scope) {
                      return [
                        scope.row.isSpu
                          ? [
                              scope.row.status == 1
                                ? _c("span", [_vm._v(" 已保存 ")])
                                : _vm._e(),
                              scope.row.status == 2
                                ? _c(
                                    "span",
                                    { staticStyle: { color: "#1890ff" } },
                                    [_vm._v(" 待审核 ")]
                                  )
                                : _vm._e(),
                              scope.row.status == 9
                                ? _c(
                                    "span",
                                    { staticStyle: { color: "#ff7f27" } },
                                    [_vm._v(" 店铺驳回 ")]
                                  )
                                : _vm._e(),
                              scope.row.status == 5
                                ? _c(
                                    "span",
                                    { staticStyle: { color: "#188506" } },
                                    [_vm._v(" 出售中 ")]
                                  )
                                : _vm._e(),
                              scope.row.status == 6
                                ? _c(
                                    "span",
                                    { staticStyle: { color: "red" } },
                                    [_vm._v(" 已下架 ")]
                                  )
                                : _vm._e(),
                              _c(
                                "el-tooltip",
                                {
                                  staticClass: "flex items-center",
                                  attrs: {
                                    effect: "dark",
                                    content: scope.row.rejectReason,
                                    placement: "top"
                                  }
                                },
                                [
                                  scope.row.status == 8
                                    ? _c(
                                        "div",
                                        {
                                          staticClass: "flex items-baseline",
                                          staticStyle: { color: "red" }
                                        },
                                        [
                                          _c("i", {
                                            staticClass: "el-icon-info"
                                          }),
                                          _c("div", { staticClass: "mar5-l" }, [
                                            _vm._v("强制下架")
                                          ])
                                        ]
                                      )
                                    : _vm._e()
                                ]
                              ),
                              _c(
                                "el-tooltip",
                                {
                                  staticClass: "flex items-center",
                                  attrs: {
                                    effect: "dark",
                                    content: scope.row.rejectReason,
                                    placement: "top"
                                  }
                                },
                                [
                                  scope.row.status == 3
                                    ? _c(
                                        "div",
                                        {
                                          staticClass: "flex items-baseline",
                                          staticStyle: { color: "#ff7f27" }
                                        },
                                        [
                                          _c("i", {
                                            staticClass: "el-icon-info"
                                          }),
                                          _c("div", { staticClass: "mar5-l" }, [
                                            _vm._v("驳回")
                                          ])
                                        ]
                                      )
                                    : _vm._e()
                                ]
                              )
                            ]
                          : [
                              _c("div", { staticClass: "nodata_line_color" }, [
                                _vm._v("——")
                              ])
                            ]
                      ]
                    }
                  }
                ])
              }),
              _c("el-table-column", {
                attrs: { label: "企联网商品", "min-width": "10%" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function(scope) {
                      return [
                        scope.row.isSpu
                          ? [
                              _c("span", [
                                _vm._v(_vm._s(scope.row.isoa ? "是" : "否"))
                              ])
                            ]
                          : [
                              _c("div", { staticClass: "nodata_line_color" }, [
                                _vm._v("——")
                              ])
                            ]
                      ]
                    }
                  }
                ])
              }),
              _c("el-table-column", {
                attrs: { label: "操作", width: "420" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function(scope) {
                      return [
                        scope.row.isSpu
                          ? [
                              scope.row.status != 2 && scope.row.status != 3
                                ? _c(
                                    "el-button",
                                    {
                                      attrs: { size: "mini" },
                                      on: {
                                        click: function($event) {
                                          return _vm.editSpuClick(scope.row)
                                        }
                                      }
                                    },
                                    [_vm._v("编辑")]
                                  )
                                : _vm._e(),
                              scope.row.status == 5
                                ? _c(
                                    "el-button",
                                    {
                                      attrs: { size: "mini" },
                                      on: {
                                        click: function($event) {
                                          return _vm.oneXiaJia(scope.row)
                                        }
                                      }
                                    },
                                    [_vm._v("下架")]
                                  )
                                : _vm._e(),
                              scope.row.status == 1 || scope.row.status == 6
                                ? _c(
                                    "el-button",
                                    {
                                      attrs: { size: "mini" },
                                      on: {
                                        click: function($event) {
                                          return _vm.oneShangJia(scope.row)
                                        }
                                      }
                                    },
                                    [_vm._v("上架")]
                                  )
                                : _vm._e(),
                              scope.row.status == 2
                                ? _c(
                                    "el-button",
                                    {
                                      attrs: { size: "mini" },
                                      on: {
                                        click: function($event) {
                                          return _vm.cancelAudit(scope.row)
                                        }
                                      }
                                    },
                                    [_vm._v("取消审核")]
                                  )
                                : _vm._e(),
                              scope.row.status == 3
                                ? _c(
                                    "el-button",
                                    {
                                      attrs: { size: "mini" },
                                      on: {
                                        click: function($event) {
                                          return _vm.editSpuClick(scope.row)
                                        }
                                      }
                                    },
                                    [_vm._v("重新编辑")]
                                  )
                                : _vm._e(),
                              scope.row.status == 1 ||
                              scope.row.status == 3 ||
                              scope.row.status == 6 ||
                              scope.row.status == 8
                                ? _c(
                                    "el-button",
                                    {
                                      attrs: { size: "mini" },
                                      on: {
                                        click: function($event) {
                                          return _vm.goodsDeleteClick(scope.row)
                                        }
                                      }
                                    },
                                    [_vm._v("删除")]
                                  )
                                : _vm._e(),
                              scope.row.status != 3
                                ? _c(
                                    "el-button",
                                    {
                                      attrs: { size: "mini" },
                                      on: {
                                        click: function($event) {
                                          return _vm.lookQRCodeClick(scope.row)
                                        }
                                      }
                                    },
                                    [_vm._v("二维码")]
                                  )
                                : _vm._e(),
                              scope.row.togetherLaddersPrice == 1
                                ? _c(
                                    "el-button",
                                    {
                                      attrs: { type: "primary", size: "mini" },
                                      on: {
                                        click: function($event) {
                                          return _vm.commonLaddersPriceConfig(
                                            scope.row,
                                            0
                                          )
                                        }
                                      }
                                    },
                                    [_vm._v("关闭共用阶梯")]
                                  )
                                : _vm._e(),
                              !scope.row.togetherLaddersPrice &&
                              scope.row.specialList &&
                              scope.row.specialList.length === 1 &&
                              _vm.enableLaddersPrice != "0" &&
                              !scope.row.isoa
                                ? _c(
                                    "el-button",
                                    {
                                      attrs: { size: "mini", type: "primary" },
                                      on: {
                                        click: function($event) {
                                          return _vm.commonLaddersPriceConfig(
                                            scope.row,
                                            1
                                          )
                                        }
                                      }
                                    },
                                    [_vm._v("启用共用阶梯")]
                                  )
                                : _vm._e()
                            ]
                          : [
                              scope.row.status != 3
                                ? _c(
                                    "el-button",
                                    {
                                      attrs: { size: "mini" },
                                      on: {
                                        click: function($event) {
                                          return _vm.lookQRCodeClick(scope.row)
                                        }
                                      }
                                    },
                                    [_vm._v("二维码")]
                                  )
                                : _vm._e()
                            ],
                        !scope.row.specType &&
                        _vm.enableLaddersPrice != "0" &&
                        !scope.row.isoa
                          ? [
                              _c(
                                "el-button",
                                {
                                  attrs: { size: "mini", type: "primary" },
                                  on: {
                                    click: function($event) {
                                      return _vm.laddersPriceConfig(
                                        scope.$index,
                                        scope.row
                                      )
                                    }
                                  }
                                },
                                [_vm._v("阶梯价")]
                              )
                            ]
                          : _vm._e()
                      ]
                    }
                  }
                ])
              })
            ],
            1
          )
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "bottom-handle-box" },
        [
          _c(
            "el-checkbox",
            {
              model: {
                value: _vm.selectAll,
                callback: function($$v) {
                  _vm.selectAll = $$v
                },
                expression: "selectAll"
              }
            },
            [_vm._v("全选")]
          ),
          _c("el-divider", { attrs: { direction: "vertical" } }),
          _c(
            "el-button",
            {
              staticStyle: { color: "#606266" },
              attrs: { type: "text" },
              on: { click: _vm.batchShangJia }
            },
            [_vm._v("批量上架")]
          ),
          _c(
            "el-button",
            {
              staticStyle: { color: "#606266" },
              attrs: { type: "text" },
              on: { click: _vm.batchXiaJia }
            },
            [_vm._v("批量下架")]
          ),
          _c(
            "el-button",
            {
              staticStyle: { color: "#606266" },
              attrs: { type: "text" },
              on: { click: _vm.batchaddCate }
            },
            [_vm._v("批量分类")]
          ),
          _c(
            "el-button",
            {
              staticStyle: { color: "#606266" },
              attrs: { type: "text" },
              on: { click: _vm.batchDeleteClassify }
            },
            [_vm._v("移除分类")]
          ),
          _c(
            "el-button",
            {
              staticStyle: { color: "#606266" },
              attrs: { type: "text" },
              on: { click: _vm.batchEditGoods }
            },
            [_vm._v("批量编辑")]
          )
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "pagination-box" },
        [
          _c("el-pagination", {
            attrs: {
              background: "",
              layout: "prev, pager, next",
              total: _vm.total,
              "current-page": _vm.currentPage
            },
            on: { "current-change": _vm.handleCurrentChange }
          })
        ],
        1
      ),
      _vm.showCategoryDialog
        ? _c("CategoryDialog", {
            ref: "categoryDialogref",
            attrs: {
              isEdit: _vm.categoryIsEdit,
              showCategoryDialog: _vm.showCategoryDialog
            },
            on: {
              "update:showCategoryDialog": function($event) {
                _vm.showCategoryDialog = $event
              },
              "update:show-category-dialog": function($event) {
                _vm.showCategoryDialog = $event
              },
              reloadspuList: _vm.reloadspuList
            }
          })
        : _vm._e(),
      _c(
        "el-dialog",
        {
          attrs: {
            title: _vm.selfOperatedShop ? "爆品活动" : "二维码",
            visible: _vm.showQRCodeDialog,
            width: "300px"
          },
          on: {
            "update:visible": function($event) {
              _vm.showQRCodeDialog = $event
            }
          }
        },
        [
          _c(
            "el-row",
            { attrs: { type: "flex", justify: "center" } },
            [
              _vm.selfOperatedShop
                ? _c(
                    "div",
                    { staticClass: "relative text-center operated-shop" },
                    [
                      _c("div", [
                        _vm._v("保存二维码或链接直接分享好友参加活动")
                      ]),
                      _c("img", {
                        staticClass: "mar10-tb",
                        attrs: { src: _vm.qrDate.qrcodeImgUrl }
                      }),
                      _c(
                        "div",
                        { staticClass: "pad10-tb" },
                        [
                          _c(
                            "el-button",
                            {
                              attrs: { size: "mini", type: "primary" },
                              on: { click: _vm.qrcodeImgUrlDown }
                            },
                            [_vm._v("下载二维码")]
                          )
                        ],
                        1
                      ),
                      _c(
                        "div",
                        { staticClass: "flex justify-center mar20-t" },
                        [
                          _c("div", [_vm._v(_vm._s(_vm.qrDate.shareUrl))]),
                          _c(
                            "div",
                            {
                              staticClass: "blue pad10-lr pointer",
                              on: { click: _vm.copyLink }
                            },
                            [_vm._v("复制")]
                          )
                        ]
                      )
                    ]
                  )
                : [
                    _c("div", { staticClass: "qrCode-box" }, [
                      _c("canvas", { ref: "qrCodeCanvas" }),
                      _c(
                        "div",
                        { staticClass: "img-box" },
                        [
                          _c("el-image", {
                            staticStyle: { width: "30px", height: "30px" },
                            attrs: { src: _vm.showQRDialogImgUrl, fit: "cover" }
                          })
                        ],
                        1
                      )
                    ])
                  ]
            ],
            2
          )
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          attrs: {
            title: "阶梯价设置",
            visible: _vm.goodPriceVisible,
            "close-on-click-modal": false,
            width: "600px"
          },
          on: {
            "update:visible": function($event) {
              _vm.goodPriceVisible = $event
            }
          }
        },
        [
          [
            _c(
              "el-form",
              [
                _c(
                  "el-form-item",
                  {
                    staticClass: "mar10-r",
                    attrs: { label: "阶梯价：", prop: "mobile" }
                  },
                  [
                    _c(
                      "el-radio-group",
                      {
                        on: { change: _vm.laddersPriceEnableChange },
                        model: {
                          value: _vm.goodsEnableLaddersPrice,
                          callback: function($$v) {
                            _vm.goodsEnableLaddersPrice = $$v
                          },
                          expression: "goodsEnableLaddersPrice"
                        }
                      },
                      [
                        _c("el-radio", { attrs: { label: 1 } }, [
                          _vm._v("启用")
                        ]),
                        _c("el-radio", { attrs: { label: 0 } }, [
                          _vm._v("不启用")
                        ])
                      ],
                      1
                    )
                  ],
                  1
                )
              ],
              1
            ),
            _vm.showLaddersPriceSetting
              ? [
                  _c(
                    "div",
                    { staticClass: "pad20_b" },
                    [
                      _c(
                        "el-button",
                        {
                          staticClass: "mar10-r",
                          attrs: { type: "primary" },
                          on: { click: _vm.addGoodPrice }
                        },
                        [_vm._v("添加")]
                      ),
                      _c("i", { staticClass: "el-icon-question" }),
                      _c("span", { staticClass: "mar5-l" }, [
                        _vm._v(
                          "最多设置三级阶梯，阶梯量逐级递增，阶梯价逐级递减且不可高于市场价"
                        )
                      ])
                    ],
                    1
                  ),
                  _c(
                    "el-table",
                    {
                      staticClass: "goodPriceTable",
                      staticStyle: { width: "100%" },
                      attrs: { data: _vm.goodsPriceList }
                    },
                    [
                      _c("el-table-column", {
                        attrs: { prop: "level", label: "阶梯", width: "100" }
                      }),
                      _c("el-table-column", {
                        attrs: {
                          prop: "minQuantity",
                          label: "阶梯量(" + _vm.laddersSkuUnit + ")"
                        },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "default",
                              fn: function(scope) {
                                return [
                                  _c("span", { staticClass: "mar5-r" }, [
                                    _vm._v("≥")
                                  ]),
                                  _c("el-input", {
                                    attrs: {
                                      oninput:
                                        "value=value.replace(/\\D|^0/g,'')"
                                    },
                                    model: {
                                      value: scope.row.minQuantity,
                                      callback: function($$v) {
                                        _vm.$set(scope.row, "minQuantity", $$v)
                                      },
                                      expression: "scope.row.minQuantity"
                                    }
                                  })
                                ]
                              }
                            }
                          ],
                          null,
                          false,
                          4089653134
                        )
                      }),
                      _c("el-table-column", {
                        attrs: { prop: "price", label: "阶梯价(￥)" },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "default",
                              fn: function(scope) {
                                return [
                                  _c("el-input", {
                                    on: {
                                      blur: function($event) {
                                        scope.row.price = _vm.formatNums(
                                          scope.row.price,
                                          true
                                        )
                                      }
                                    },
                                    model: {
                                      value: scope.row.price,
                                      callback: function($$v) {
                                        _vm.$set(scope.row, "price", $$v)
                                      },
                                      expression: "scope.row.price"
                                    }
                                  })
                                ]
                              }
                            }
                          ],
                          null,
                          false,
                          755993547
                        )
                      }),
                      _c("el-table-column", {
                        attrs: { label: "操作", width: "100" },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "default",
                              fn: function(scope) {
                                return [
                                  _vm.goodsPriceList.length > 2 &&
                                  scope.row.level !== 1 &&
                                  scope.row.level !== 2
                                    ? _c("i", {
                                        staticClass: "el-icon-delete cursor",
                                        on: {
                                          click: function($event) {
                                            return _vm.delGoodPrice(
                                              scope.$index
                                            )
                                          }
                                        }
                                      })
                                    : _vm._e()
                                ]
                              }
                            }
                          ],
                          null,
                          false,
                          3255349528
                        )
                      })
                    ],
                    1
                  )
                ]
              : _vm._e()
          ],
          _c(
            "span",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer"
            },
            [
              _c(
                "el-button",
                {
                  on: {
                    click: function($event) {
                      _vm.goodPriceVisible = false
                    }
                  }
                },
                [_vm._v("取 消")]
              ),
              _c(
                "el-button",
                {
                  attrs: { type: "primary" },
                  on: { click: _vm.goodsPriceConfirm }
                },
                [_vm._v("确 定")]
              )
            ],
            1
          )
        ],
        2
      )
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", [_c("h2", [_vm._v("商品管理")])])
  }
]
render._withStripped = true

export { render, staticRenderFns }